import { useSelector } from 'react-redux'
import { ImageNames, svgImageNames } from 'src/enums'
import { selectBrandFeaturesFromState } from 'src/redux/selectors/session.selectors'
import { returnImage, returnSvgComponent } from 'src/utils/images.utils'

export const useColorOrGrayscaleImage = (imageName: ImageNames): string => {
  const { grayscaleImageEnabled } = useSelector(selectBrandFeaturesFromState)
  return returnImage(imageName, grayscaleImageEnabled)
}

export const useColorOrGrayscaleSVG = (
  svgImageName: svgImageNames,
): React.ReactElement => {
  const { grayscaleImageEnabled } = useSelector(selectBrandFeaturesFromState)
  return returnSvgComponent(svgImageName, grayscaleImageEnabled)
}
